
        import 'MyQuotes.5973b81.css-module'
        export default {"myQuotesHeader":"myQuotesHeader_MyQuotes_5973b81","goToQuote":"goToQuote_MyQuotes_5973b81","addQuote":"addQuote_MyQuotes_5973b81"}
    